import { render } from "./BaktaAnalyzer.vue?vue&type=template&id=0a2a1a92&scoped=true"
import script from "./BaktaAnalyzer.vue?vue&type=script&lang=js"
export * from "./BaktaAnalyzer.vue?vue&type=script&lang=js"

import "./BaktaAnalyzer.vue?vue&type=style&index=0&id=0a2a1a92&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a2a1a92"]])

export default __exports__